<template>
    <div class="wf-relative dropdown-menu">
        <button @click.prevent="menuOpen = ! menuOpen" class="focus:wf-outline-none">
            <slot name="trigger"></slot>
        </button>
        <div class="wf-absolute wf-right-0" v-show="menuOpen">
            <div class="wf-bg-white wf-rounded-md wf-border wf-shadow-lg wf-mt-2">
                <slot name="menu"></slot>    
            </div>
            
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                menuOpen: false
            }
        },
        watch: {
            menuOpen(value) {
                if (value) {
                    document.addEventListener('click', this.closeIfClickedOutside)
                }
            }
        },
        methods: {
            closeIfClickedOutside(event) {
                if (! event.target.closest('.dropdown-menu')) {
                    this.menuOpen = false
                }
            }
        }
    }
</script>